module.exports = {
    bindings: {
        measure: '<'
    },
    templateUrl: 'vat-rates/components/vat-measure.html'
}